import React from "react";
import MiniLoader from "../dashboard/MiniLoader";
import { Doughnut } from "react-chartjs-2";

const DoughnutChart = ({ isLoadingVisitors, visitors }) => {
  const deviceTypes = visitors?.deviceTypes || { mobile: 0, desktop: 0, tablet: 0 };
  const hasData = deviceTypes.mobile + deviceTypes.desktop + deviceTypes.tablet > 0;

  return (
    <div className=" flex min-h-[20rem] w-full items-center justify-center rounded-md bg-white px-2 py-4 shadow-lg dark:bg-dashboardBg">
      {isLoadingVisitors ? (
        <MiniLoader />
      ) : !hasData ? (
        <p className="text-sm text-gray-500 dark:text-gray-400">No device data yet</p>
      ) : (
        <Doughnut
          data={{
            labels: ["Mobile", "Desktop", "Tablet"],
            datasets: [
              {
                label: "Device",
                data: [deviceTypes.mobile, deviceTypes.desktop, deviceTypes.tablet],
                borderRadius: 2,
                borderWidth: 0,
              },
            ],
          }}
          options={{
            plugins: {
              title: {
                text: "Device Resource",
              },
            },
          }}
        />
      )}
    </div>
  );
};

export default DoughnutChart;
